module.exports = require("./dav.d.ts");